import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import LinkButton from '@/components/link_button/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import { VoucherStatus } from '@/helpers/entities/enums/v2/VoucherStatus';
let Vouchers = class Vouchers extends Mixins(ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.valid = VoucherStatus.Valid;
        this.redeemed = VoucherStatus.Redeemed;
    }
    get status() {
        return this.$route.params.status;
    }
};
Vouchers = __decorate([
    Component({
        components: {
            PageTitle,
            LinkButton,
        },
    })
], Vouchers);
export default Vouchers;
